import "core-js/modules/es.array.push.js";
import axios from "axios";
import moment from "moment";
import * as XLSX from "xlsx";

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      dateRange: [],
      classCourseTeacherHour: {},
      oriClassCourseTeacherHour: {},
      classCourseTeacherArr: {},
      oriClassCourseTeacherArr: {},
      teacherClassCourseHour: {},
      oriTeacherClassCourseHour: {},
      teacherClassCourseArr: {},
      oriTeacherClassCourseArr: {},
      studentClassCourseHour: {},
      oriStudentClassCourseHour: {},
      studentClassCourseArr: {},
      oriStudentClassCourseArr: {},
      teacherHours: {},
      classHours: {},
      studentHours: {},
      teacherNames: {},
      classNames: {},
      classType: {},
      classCampusId: {},
      campusNames: {},
      studentNames: {},
      // 搜索
      searchStr: "",
      showSearchResult: false,
      totalHour: 0,
      searchPlaceholder: "",
      // 班级/老师/学生 切换
      showStatisticsType: "class"
    };
  },
  async mounted() {
    // 获取当前月第一天和最后一天
    this.getCurrentMonthRange();

    // 获取课时统计
    this.getClassCourseTeacherHour();
  },
  methods: {
    // 获取当前月第一天和最后一天
    getCurrentMonthRange() {
      const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
      const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
      this.dateRange = [startOfMonth, endOfMonth];
    },
    // 获取课时统计
    async getClassCourseTeacherHour() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          dateRange: this.dateRange,
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseStatistics/getClassCourseTeacherHour", params);
        if (resp1.data.code == "0000") {
          // 班级课时
          this.classCourseTeacherHour = resp1.data.data.classCourseTeacherHour;
          if (this.classCourseTeacherHour) {
            this.oriClassCourseTeacherHour = JSON.parse(JSON.stringify(this.classCourseTeacherHour));
          }
          this.classHours = {};
          // 计算每个班级的课时合计
          for (let classId in this.classCourseTeacherHour) {
            let classTotalHour = 0;
            for (let course in this.classCourseTeacherHour[classId]) {
              for (let teacherId in this.classCourseTeacherHour[classId][course]) {
                classTotalHour += this.classCourseTeacherHour[classId][course][teacherId].hour;
              }
            }
            this.classHours[classId] = classTotalHour;
          }

          // 老师课时
          this.teacherClassCourseHour = resp1.data.data.teacherClassCourseHour;
          if (this.teacherClassCourseHour) {
            this.oriTeacherClassCourseHour = JSON.parse(JSON.stringify(this.teacherClassCourseHour));
          }
          this.teacherHours = {};
          // 计算每个老师合计课时
          for (let teacherId in this.teacherClassCourseHour) {
            let teacherTotalHour = 0;
            for (let classId in this.teacherClassCourseHour[teacherId]) {
              for (let course in this.teacherClassCourseHour[teacherId][classId]) {
                teacherTotalHour += this.teacherClassCourseHour[teacherId][classId][course].hour;
              }
            }
            this.teacherHours[teacherId] = teacherTotalHour;
          }

          // 学生课时
          this.studentClassCourseHour = resp1.data.data.studentClassCourseHour;
          if (this.studentClassCourseHour) {
            this.oriStudentClassCourseHour = JSON.parse(JSON.stringify(this.studentClassCourseHour));
          }
          this.studentHours = {};

          // 计算每个学生合计课时
          for (let studentId in this.studentClassCourseHour) {
            let studentTotalHour = 0;
            for (let classId in this.studentClassCourseHour[studentId]) {
              for (let course in this.studentClassCourseHour[studentId][classId]) {
                studentTotalHour += this.studentClassCourseHour[studentId][classId][course].hour;
              }
            }
            this.studentHours[studentId] = studentTotalHour;
          }
          this.classNames = resp1.data.data.classNames;
          this.classType = resp1.data.data.classType;
          this.classCampusId = resp1.data.data.classCampusId;
          this.campusNames = resp1.data.data.campusNames;
          this.teacherNames = resp1.data.data.teacherNames;
          this.studentNames = resp1.data.data.studentNames;

          // 班级 科目 老师 有哪些课
          this.classCourseTeacherArr = resp1.data.data.classCourseTeacherArr;
          if (this.classCourseTeacherArr) {
            this.oriClassCourseTeacherArr = JSON.parse(JSON.stringify(this.classCourseTeacherArr));
          }

          // 老师 班级 科目 有哪些课
          this.teacherClassCourseArr = resp1.data.data.teacherClassCourseArr;
          if (this.teacherClassCourseArr) {
            this.oriTeacherClassCourseArr = JSON.parse(JSON.stringify(this.teacherClassCourseArr));
          }

          // 学生 班级 科目 有哪些课
          this.studentClassCourseArr = resp1.data.data.studentClassCourseArr;
          if (this.studentClassCourseArr) {
            this.oriStudentClassCourseArr = JSON.parse(JSON.stringify(this.studentClassCourseArr));
          }

          // 统计课时
          this.search();
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:" + error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    dateRangeChange() {
      console.log("this.dateRange:", this.dateRange);
      this.getClassCourseTeacherHour();
    },
    search() {
      // 班级统计
      if (this.showStatisticsType == "class") {
        this.classCourseTeacherHour = {};
        this.classCourseTeacherArr = {};
        this.totalHour = 0;
        this.showSearchResult = true;

        // if (this.searchStr == "") {
        //   return;
        // }

        for (let classId in this.oriClassCourseTeacherHour) {
          // 如果班级名包含搜索内容
          if (this.classNames[classId].toLowerCase().includes(this.searchStr.toLowerCase())) {
            this.classCourseTeacherHour[classId] = this.oriClassCourseTeacherHour[classId];
            this.classCourseTeacherArr[classId] = this.oriClassCourseTeacherArr[classId];
          }
        }

        // 计算课时合计
        for (let classId in this.classCourseTeacherHour) {
          for (let course in this.classCourseTeacherHour[classId]) {
            for (let teacherId in this.classCourseTeacherHour[classId][course]) {
              this.totalHour = this.totalHour + this.classCourseTeacherHour[classId][course][teacherId].hour;
            }
          }
        }
      }
      // 老师统计
      if (this.showStatisticsType == "teacher") {
        this.teacherClassCourseHour = {};
        this.teacherClassCourseArr = {};
        this.totalHour = 0;

        // if (this.searchStr == "") {
        //   return;
        // }

        for (let teacherId in this.oriTeacherClassCourseHour) {
          // 如果老师名包含搜索内容
          if (this.teacherNames[teacherId].toLowerCase().includes(this.searchStr.toLowerCase())) {
            this.teacherClassCourseHour[teacherId] = this.oriTeacherClassCourseHour[teacherId];
            this.teacherClassCourseArr[teacherId] = this.oriTeacherClassCourseArr[teacherId];
          }
        }

        // 统计课时
        for (let teacherId in this.teacherClassCourseHour) {
          for (let classId in this.teacherClassCourseHour[teacherId]) {
            for (let course in this.teacherClassCourseHour[teacherId][classId]) {
              this.totalHour = this.totalHour + this.teacherClassCourseHour[teacherId][classId][course].hour;
            }
          }
        }
        this.showSearchResult = true;
      }
    },
    cancelSearch() {
      this.searchStr = "";

      // 恢复原始数据
      if (this.showStatisticsType == "class") {
        this.classCourseTeacherHour = this.oriClassCourseTeacherHour;
        this.classCourseTeacherArr = this.oriClassCourseTeacherArr;
      }
      if (this.showStatisticsType == "teacher") {
        this.teacherClassCourseHour = this.oriTeacherClassCourseHour;
        this.teacherClassCourseArr = this.oriTeacherClassCourseArr;
      }
      this.showSearchResult = false;
    },
    // 班级，老师 切换
    classTeacherSwitch(type) {
      // 搜索栏清空
      this.cancelSearch();
      // 重新计算累计课时
      this.search();
      this.showStatisticsType = type;
      if (type == "class") {
        this.searchPlaceholder = "搜索班级";
      } else if (type == "teacher") {
        this.searchPlaceholder = "搜索老师";
      } else if (type == "student") {
        this.searchPlaceholder = "搜索学生";
      }
    },
    // 导出课时统计excel 选择导出每节课详细还是不详细
    downloadStatistics() {
      this.showDownloadConfirm = true;
    },
    downloadStatisticsConfirm() {
      if (this.downloadDetail) {
        this.downloadStatistics_withDetail();
      } else {
        this.downloadStatistics_withoutDetail();
      }
    },
    downloadStatisticsCancel() {
      this.showDownloadConfirm = false;
    },
    // 导出课时统计excel （包含每节课的详情）
    downloadStatistics_withDetail() {
      // 班级课时统计
      if (this.showStatisticsType == "class") {
        try {
          const exportData = [];
          const mergeCells = [];

          // 添加表头
          exportData.push(["班级名称", "班级类型", "校区名称", "科目", "老师姓名", "上课日期", "上课时间", "老师课时合计(小时)", "班级课时合计(小时)"]);
          let currentClassId = null;
          let classRowStart = 1; // 第一行是表头，所以数据从第2行开始

          for (let classId in this.classCourseTeacherHour) {
            const classItem = this.classCourseTeacherHour[classId];

            // 如果是第一个条目，或者班级ID变了，则记录起始行
            if (currentClassId !== classId) {
              currentClassId = classId;
              classRowStart = exportData.length; // 记录当前班级的第一行行数
            }
            let currentCourseId = null;
            let courseRowStart = 1;

            // 遍历该班级的所有课程和老师
            for (let course in classItem) {
              // 如果是第一个条目，或者科目 变了，则记录起始行
              if (currentCourseId !== course) {
                currentCourseId = course;
                courseRowStart = exportData.length;
              }
              let currentTeacherId = null;
              let teacherRowStart = 1;
              for (let teacherId in classItem[course]) {
                const item = classItem[course][teacherId];

                // 如果是第一个条目，或者老师 ID 变了，则记录起始行
                if (currentTeacherId !== teacherId) {
                  currentTeacherId = teacherId;
                  teacherRowStart = exportData.length;
                }
                let classCourseTeacherArr = this.classCourseTeacherArr[classId][course][teacherId];
                for (let i in classCourseTeacherArr) {
                  const courseItem = classCourseTeacherArr[i];

                  // 添加数据行
                  exportData.push([item.className,
                  // 班级名（后续会被合并）
                  item.classType, item.campusName, item.course, item.teacherName, courseItem.date, courseItem.period, item.hour, this.classHours[classId]]);
                }

                // 计算当前老师的数据行数
                const teacherRowCount = exportData.length - teacherRowStart;

                // 合并 老师姓名（E列）
                mergeCells.push(`E${teacherRowStart + 1}:E${teacherRowStart + teacherRowCount}`);
                // 合并 老师课时合计（H列）
                mergeCells.push(`H${teacherRowStart + 1}:H${teacherRowStart + teacherRowCount}`);
              }

              // 计算当前科目的数据行数
              const courseRowCount = exportData.length - courseRowStart;

              // 合并 科目（D列）
              mergeCells.push(`D${courseRowStart + 1}:D${courseRowStart + courseRowCount}`);
            }

            // 计算当前班级的数据行数
            const rowCount = exportData.length - classRowStart;

            // 合并 班级名称（A列）
            mergeCells.push(`A${classRowStart + 1}:A${classRowStart + rowCount}`);
            // 合并 班级类型（B列）
            mergeCells.push(`B${classRowStart + 1}:B${classRowStart + rowCount}`);
            // 合并 校区名称（C列）
            mergeCells.push(`C${classRowStart + 1}:C${classRowStart + rowCount}`);
            // 合并 合计课时（I列）
            mergeCells.push(`I${classRowStart + 1}:I${classRowStart + rowCount}`);
          }

          // console.log("mergeCells:", mergeCells);

          // 创建工作簿
          const ws = XLSX.utils.aoa_to_sheet(exportData);

          // 设置合并单元格
          // 将之前收集的所有合并区域（如 "A2:A4", "B2:B4" 等）转换成 xlsx 库能识别的格式
          ws["!merges"] = mergeCells.map(range => {
            // 示例：range = "A2:A4"
            const [start, end] = range.split(":"); // 分割成 ["A2", "A4"]

            // 安全解析起始单元格
            const startMatch = start.match(/([A-Z]+)(\d+)/);
            if (!startMatch) {
              console.warn("Invalid start cell:", start);
              return; // 跳过无效项
            }

            // 解析起始单元格（如 A2）
            const [startRow, startCol] = start.match(/([A-Z]+)(\d+)/) // 匹配数字和字母部分，比如 "2" 和 "A"
            .slice(1) // 取匹配到的两个组：["2", "A"]
            .reverse(); // 反转顺序，变成 ["A", "2"] → 方便后续处理

            // 解析结束单元格（如 A4）
            const [endRow, endCol] = end.match(/([A-Z]+)(\d+)/).slice(1).reverse();

            // 返回一个对象，表示合并区域的起始和结束坐标
            return {
              s: {
                // s 表示 start（起始）
                r: parseInt(startRow) - 1,
                // 行号从0开始，所以减1（Excel 第2行对应索引1）
                c: startCol.charCodeAt(0) - 65 // 列号转换：'A'=65 → 0, 'B'=66 → 1
              },
              e: {
                // e 表示 end（结束）
                r: parseInt(endRow) - 1,
                c: endCol.charCodeAt(0) - 65
              }
            };
          });

          // 设置列宽 (单位：字符数)
          ws["!cols"] = [{
            wch: 40
          },
          // A列 班级名称
          {
            wch: 15
          },
          // B列 班级类型
          {
            wch: 15
          },
          // C列 校区名称
          {
            wch: 15
          },
          // D列 科目
          {
            wch: 15
          },
          // E列 老师姓名
          {
            wch: 12
          },
          // F列 课时 (小时)
          {
            wch: 12
          } // G列 课时合计
          ];

          // 设置单元格样式 - 垂直水平居中
          const range = XLSX.utils.decode_range(ws["!ref"]);
          for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
              const cellAddress = XLSX.utils.encode_cell({
                r: R,
                c: C
              });
              if (!ws[cellAddress]) continue;

              // 设置单元格样式
              ws[cellAddress].s = {
                alignment: {
                  vertical: "center",
                  // 垂直居中
                  horizontal: "center",
                  // 水平居中
                  wrapText: true // 自动换行
                },
                font: {
                  sz: 12,
                  // 字体大小
                  bold: R === 0 // 表头加粗
                },
                border: {
                  top: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                }
              };
            }
          }

          // 设置行高
          ws["!rows"] = [];
          for (let R = range.s.r; R <= range.e.r; ++R) {
            ws["!rows"][R] = {
              hpt: 25
            }; // 行高 25 像素
          }

          // 创建工作簿
          const wb = XLSX.utils.book_new();
          // 添加工作表
          XLSX.utils.book_append_sheet(wb, ws, "sheet1");
          const fileName = `班级课时统计_含每节课详情_${this.dateRange[0]}-${this.dateRange[1]}.xlsx`;
          // 导出
          XLSX.writeFile(wb, fileName);
          console.log("导出成功");
        } catch (error) {
          console.error("导出失败:", error);
          alert("导出失败: " + error.message);
        }
      }
      // 老师课时统计
      if (this.showStatisticsType == "teacher") {
        try {
          const exportData = [];
          const mergeCells = [];

          // 添加表头
          exportData.push(["老师姓名", "班级名称", "班级类型", "校区名称", "科目", "上课日期", "上课时间", "科目课时合计 (小时)", "老师课时合计 (小时)"]);
          let currentTeacherId = null;
          let teacherRowStart = 1;
          for (let teacherId in this.teacherClassCourseHour) {
            const teacherItem = this.teacherClassCourseHour[teacherId];

            // 如果是第一个条目，或者老师 ID 变了，则记录起始行
            if (currentTeacherId !== teacherId) {
              currentTeacherId = teacherId;
              teacherRowStart = exportData.length;
            }
            let currentClassId = null;
            let classRowStart = 1;

            // 遍历该老师的所有班级和科目
            for (let classId in teacherItem) {
              // 如果是第一个条目，或者班级 ID 变了，则记录起始行
              if (currentClassId !== classId) {
                currentClassId = classId;
                classRowStart = exportData.length;
              }
              let currentCourse = null;
              let courseRowStart = 1;
              for (let course in teacherItem[classId]) {
                // 如果是第一个条目，或者科目变了，则记录起始行
                if (currentCourse !== course) {
                  currentCourse = course;
                  courseRowStart = exportData.length;
                }
                let item = teacherItem[classId][course];
                let courseArr = this.teacherClassCourseArr[teacherId][classId][course];

                // 科目的每节课
                for (let i in courseArr) {
                  const courseItem = courseArr[i];

                  // 添加数据行
                  exportData.push([item.teacherName,
                  // 老师姓名（后续会被合并）
                  item.className, item.classType, item.campusName, item.course, courseItem.date, courseItem.period, item.hour, this.teacherHours[teacherId] // 课时合计（后续会被合并）
                  ]);
                }

                // 计算当前科目的数据行数
                const courseRowCount = exportData.length - courseRowStart;

                // 合并 科目（E 列）
                mergeCells.push(`E${courseRowStart + 1}:E${courseRowStart + courseRowCount}`);

                // 合并 科目课时合计（H 列）
                mergeCells.push(`H${courseRowStart + 1}:H${courseRowStart + courseRowCount}`);
              }

              // 计算当前班级的数据行数
              const classRowCount = exportData.length - classRowStart;

              // 合并 班级名称（B 列）
              mergeCells.push(`B${classRowStart + 1}:B${classRowStart + classRowCount}`);
              // 合并 班级类型（C 列）
              mergeCells.push(`C${classRowStart + 1}:C${classRowStart + classRowCount}`);
              // 合并 校区名称（D 列）
              mergeCells.push(`D${classRowStart + 1}:D${classRowStart + classRowCount}`);
            }

            // 计算当前老师的数据行数
            const teacherRowCount = exportData.length - teacherRowStart;

            // 合并 老师姓名（A 列）
            mergeCells.push(`A${teacherRowStart + 1}:A${teacherRowStart + teacherRowCount}`);
            // 合并 课时合计（I 列）
            mergeCells.push(`I${teacherRowStart + 1}:I${teacherRowStart + teacherRowCount}`);
          }

          // 创建工作簿
          const ws = XLSX.utils.aoa_to_sheet(exportData);

          // 设置合并单元格
          ws["!merges"] = mergeCells.map(range => {
            const [start, end] = range.split(":");
            const startMatch = start.match(/([A-Z]+)(\d+)/);
            if (!startMatch) return;
            const [, startCol, startRow] = start.match(/([A-Z]+)(\d+)/);
            const [, endCol, endRow] = end.match(/([A-Z]+)(\d+)/);
            return {
              s: {
                r: parseInt(startRow) - 1,
                c: startCol.charCodeAt(0) - 65
              },
              e: {
                r: parseInt(endRow) - 1,
                c: endCol.charCodeAt(0) - 65
              }
            };
          });

          // 设置列宽
          ws["!cols"] = [{
            wch: 15
          },
          // A 列 老师姓名
          {
            wch: 40
          },
          // B 列 班级名称
          {
            wch: 15
          },
          // C 列 班级类型
          {
            wch: 15
          },
          // D 列 校区名称
          {
            wch: 15
          },
          // E 列 科目
          {
            wch: 15
          },
          // F 列 上课日期
          {
            wch: 15
          },
          // G 列 上课时间
          {
            wch: 12
          },
          // H 列 科目课时合计 (小时)
          {
            wch: 12
          } // I 列 老师课时合计 (小时)
          ];

          // 设置单元格样式 - 垂直水平居中
          const range = XLSX.utils.decode_range(ws["!ref"]);
          for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
              const cellAddress = XLSX.utils.encode_cell({
                r: R,
                c: C
              });
              if (!ws[cellAddress]) continue;
              ws[cellAddress].s = {
                alignment: {
                  vertical: "center",
                  horizontal: "center",
                  wrapText: true
                },
                font: {
                  sz: 12,
                  bold: R === 0
                },
                border: {
                  top: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                }
              };
            }
          }

          // 设置行高
          ws["!rows"] = [];
          for (let R = range.s.r; R <= range.e.r; ++R) {
            ws["!rows"][R] = {
              hpt: 25
            };
          }
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "sheet1");
          const fileName = `老师课时统计_含每节课详情_${this.dateRange[0]}-${this.dateRange[1]}.xlsx`;
          XLSX.writeFile(wb, fileName);
          console.log("导出成功");
        } catch (error) {
          console.error("导出失败:", error);
          alert("导出失败：" + error.message);
        }
      }
    },
    // 导出课时统计excel （不包含每节课的详情）
    downloadStatistics_withoutDetail() {
      // 班级课时统计
      if (this.showStatisticsType == "class") {
        try {
          const exportData = [];
          const mergeCells = [];

          // 添加表头
          exportData.push(["班级名称", "班级类型", "校区名称", "科目", "老师姓名", "老师课时合计(小时)", "班级课时合计(小时)"]);
          let currentClassId = null;
          let rowStart = 1; // 第一行是表头，所以数据从第2行开始

          for (let classId in this.classCourseTeacherHour) {
            const classItem = this.classCourseTeacherHour[classId];

            // 如果是第一个条目，或者班级ID变了，则记录起始行
            if (currentClassId !== classId) {
              currentClassId = classId;
              rowStart = exportData.length; // 记录当前班级的第一行行数
            }
            let currentCourseId = null;
            let courseRowStart = 1;

            // 遍历该班级的所有课程和老师
            for (let course in classItem) {
              // 如果是第一个条目，或者科目变了，则记录起始行
              if (currentCourseId !== course) {
                currentCourseId = course;
                courseRowStart = exportData.length;
              }
              for (let teacherId in classItem[course]) {
                const item = classItem[course][teacherId];

                // 添加数据行
                exportData.push([item.className,
                // 班级名（后续会被合并）
                item.classType, item.campusName, item.course, item.teacherName, item.hour, this.classHours[classId]]);
              }

              // 计算当前科目的数据行数
              const courseRowCount = exportData.length - courseRowStart;

              // 合并 科目（D列）
              mergeCells.push(`D${courseRowStart + 1}:D${courseRowStart + courseRowCount}`);
            }

            // 计算当前班级的数据行数
            const rowCount = exportData.length - rowStart;

            // 合并 班级名称（A列）
            mergeCells.push(`A${rowStart + 1}:A${rowStart + rowCount}`);
            // 合并 班级类型（B列）
            mergeCells.push(`B${rowStart + 1}:B${rowStart + rowCount}`);
            // 合并 校区名称（C列）
            mergeCells.push(`C${rowStart + 1}:C${rowStart + rowCount}`);
            // 合并 合计课时（G列）
            mergeCells.push(`G${rowStart + 1}:G${rowStart + rowCount}`);
          }

          // console.log("mergeCells:", mergeCells);

          // 创建工作簿
          const ws = XLSX.utils.aoa_to_sheet(exportData);

          // 设置合并单元格
          // 将之前收集的所有合并区域（如 "A2:A4", "B2:B4" 等）转换成 xlsx 库能识别的格式
          ws["!merges"] = mergeCells.map(range => {
            // 示例：range = "A2:A4"
            const [start, end] = range.split(":"); // 分割成 ["A2", "A4"]

            // 安全解析起始单元格
            const startMatch = start.match(/([A-Z]+)(\d+)/);
            if (!startMatch) {
              console.warn("Invalid start cell:", start);
              return; // 跳过无效项
            }

            // 解析起始单元格（如 A2）
            const [startRow, startCol] = start.match(/([A-Z]+)(\d+)/) // 匹配数字和字母部分，比如 "2" 和 "A"
            .slice(1) // 取匹配到的两个组：["2", "A"]
            .reverse(); // 反转顺序，变成 ["A", "2"] → 方便后续处理

            // 解析结束单元格（如 A4）
            const [endRow, endCol] = end.match(/([A-Z]+)(\d+)/).slice(1).reverse();

            // 返回一个对象，表示合并区域的起始和结束坐标
            return {
              s: {
                // s 表示 start（起始）
                r: parseInt(startRow) - 1,
                // 行号从0开始，所以减1（Excel 第2行对应索引1）
                c: startCol.charCodeAt(0) - 65 // 列号转换：'A'=65 → 0, 'B'=66 → 1
              },
              e: {
                // e 表示 end（结束）
                r: parseInt(endRow) - 1,
                c: endCol.charCodeAt(0) - 65
              }
            };
          });

          // 设置列宽 (单位：字符数)
          ws["!cols"] = [{
            wch: 40
          },
          // A列 班级名称
          {
            wch: 15
          },
          // B列 班级类型
          {
            wch: 15
          },
          // C列 校区名称
          {
            wch: 15
          },
          // D列 科目
          {
            wch: 15
          },
          // E列 老师姓名
          {
            wch: 12
          },
          // F列 课时 (小时)
          {
            wch: 12
          } // G列 课时合计
          ];

          // 设置单元格样式 - 垂直水平居中
          const range = XLSX.utils.decode_range(ws["!ref"]);
          for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
              const cellAddress = XLSX.utils.encode_cell({
                r: R,
                c: C
              });
              if (!ws[cellAddress]) continue;

              // 设置单元格样式
              ws[cellAddress].s = {
                alignment: {
                  vertical: "center",
                  // 垂直居中
                  horizontal: "center",
                  // 水平居中
                  wrapText: true // 自动换行
                },
                font: {
                  sz: 12,
                  // 字体大小
                  bold: R === 0 // 表头加粗
                },
                border: {
                  top: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                }
              };
            }
          }

          // 设置行高
          ws["!rows"] = [];
          for (let R = range.s.r; R <= range.e.r; ++R) {
            ws["!rows"][R] = {
              hpt: 25
            }; // 行高 25 像素
          }

          // 创建工作簿
          const wb = XLSX.utils.book_new();
          // 添加工作表
          XLSX.utils.book_append_sheet(wb, ws, "sheet1");
          const fileName = `班级课时统计_不含每节课详情_${this.dateRange[0]}-${this.dateRange[1]}.xlsx`;
          // 导出
          XLSX.writeFile(wb, fileName);
          console.log("导出成功");
        } catch (error) {
          console.error("导出失败:", error);
          alert("导出失败: " + error.message);
        }
      }
      // 老师课时统计
      if (this.showStatisticsType == "teacher") {
        try {
          const exportData = [];
          const mergeCells = [];

          // 添加表头
          exportData.push(["老师姓名", "班级名称", "班级类型", "校区名称", "科目", "科目课时合计 (小时)", "老师课时合计 (小时)"]);
          let currentTeacherId = null;
          let teacherRowStart = 1;
          for (let teacherId in this.teacherClassCourseHour) {
            const teacherItem = this.teacherClassCourseHour[teacherId];

            // 如果是第一个条目，或者老师 ID 变了，则记录起始行
            if (currentTeacherId !== teacherId) {
              currentTeacherId = teacherId;
              teacherRowStart = exportData.length;
            }

            // 遍历该老师的所有班级和课程
            for (let classId in teacherItem) {
              let currentClassId = null;
              let classRowStart = 1;

              // 如果是第一个条目，或者班级 ID 变了，则记录起始行
              if (currentClassId !== classId) {
                currentClassId = classId;
                classRowStart = exportData.length;
              }
              for (let course in teacherItem[classId]) {
                const item = teacherItem[classId][course];

                // 添加数据行
                exportData.push([item.teacherName,
                // 老师姓名（后续会被合并）
                item.className, item.classType, item.campusName, item.course, item.hour, this.teacherHours[teacherId] // 课时合计（后续会被合并）
                ]);
              }

              // 计算当前班级的数据行数
              const classRowCount = exportData.length - classRowStart;

              // 合并 班级名称（B 列）
              mergeCells.push(`B${classRowStart + 1}:B${classRowStart + classRowCount}`);
              // 合并 班级类型（C 列）
              mergeCells.push(`C${classRowStart + 1}:C${classRowStart + classRowCount}`);
              // 合并 校区名称（D 列）
              mergeCells.push(`D${classRowStart + 1}:D${classRowStart + classRowCount}`);
            }

            // 计算当前老师的数据行数
            const rowCount = exportData.length - teacherRowStart;

            // 合并 老师姓名（A 列）
            mergeCells.push(`A${teacherRowStart + 1}:A${teacherRowStart + rowCount}`);
            // 合并 课时合计（G 列）
            mergeCells.push(`G${teacherRowStart + 1}:G${teacherRowStart + rowCount}`);
          }

          // 创建工作簿
          const ws = XLSX.utils.aoa_to_sheet(exportData);

          // 设置合并单元格
          ws["!merges"] = mergeCells.map(range => {
            const [start, end] = range.split(":");
            const startMatch = start.match(/([A-Z]+)(\d+)/);
            if (!startMatch) return;
            const [, startCol, startRow] = start.match(/([A-Z]+)(\d+)/);
            const [, endCol, endRow] = end.match(/([A-Z]+)(\d+)/);
            return {
              s: {
                r: parseInt(startRow) - 1,
                c: startCol.charCodeAt(0) - 65
              },
              e: {
                r: parseInt(endRow) - 1,
                c: endCol.charCodeAt(0) - 65
              }
            };
          });

          // 设置列宽
          ws["!cols"] = [{
            wch: 15
          },
          // A 列 老师姓名
          {
            wch: 40
          },
          // B 列 班级名称
          {
            wch: 15
          },
          // C 列 班级类型
          {
            wch: 15
          },
          // D 列 校区名称
          {
            wch: 15
          },
          // E 列 科目
          {
            wch: 12
          },
          // F 列 科目课时合计 (小时)
          {
            wch: 12
          } // G 列 老师课时合计 (小时)
          ];

          // 设置单元格样式 - 垂直水平居中
          const range = XLSX.utils.decode_range(ws["!ref"]);
          for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
              const cellAddress = XLSX.utils.encode_cell({
                r: R,
                c: C
              });
              if (!ws[cellAddress]) continue;
              ws[cellAddress].s = {
                alignment: {
                  vertical: "center",
                  horizontal: "center",
                  wrapText: true
                },
                font: {
                  sz: 12,
                  bold: R === 0
                },
                border: {
                  top: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                }
              };
            }
          }

          // 设置行高
          ws["!rows"] = [];
          for (let R = range.s.r; R <= range.e.r; ++R) {
            ws["!rows"][R] = {
              hpt: 25
            };
          }
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "sheet1");
          const fileName = `老师课时统计_不含每节课详情_${this.dateRange[0]}-${this.dateRange[1]}.xlsx`;
          XLSX.writeFile(wb, fileName);
          console.log("导出成功");
        } catch (error) {
          console.error("导出失败:", error);
          alert("导出失败：" + error.message);
        }
      }
    }
  }
};